import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import LevelDot from './LevelDot';

export default class LevelDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, levelNum, levelId, startNum, endNum, width, circleSize, littleCircleSize, lineWidth) {
    super(scene);

    this.levelNum = levelNum;
    this.levelId = levelId;
    this.startNum = startNum;
    this.endNum = endNum;
    if (width === void (0)) width = 200;
    this.dotDistance = width;
    if (circleSize === void (0)) circleSize = 58;
    if (littleCircleSize === void (0)) littleCircleSize = 28;
    this.circleSize = circleSize;
    this.littleCircleSize = littleCircleSize;
    this.lineWidth = lineWidth;
    if (lineWidth === void (0)) this.lineWidth = 11;

    let dotColor = 0xcc66ff;

    let strokeSize = 4;

    this.firstDot = new LevelDot(this.scene, this.startNum, dotColor, "IntroDot", this.circleSize, strokeSize, 28, 0xffffff);
    this.firstDot.x = 0;
    this.firstDot.y = 0;

    this.lastDot = new LevelDot(this.scene, this.endNum, dotColor, "IntroDot", this.circleSize, strokeSize, 28, 0xffffff);
    this.lastDot.x = this.dotDistance + this.circleSize / 2;
    this.lastDot.y = 0;

    let littleStrokeSize = 4;
    this.middleDot = new LevelDot(this.scene, null, dotColor, "", this.littleCircleSize, littleStrokeSize, 14, 0xffffff);

    this.middleDot.x = this.dotDistance * 0.5 + this.littleCircleSize * 0.5;

    this.connectLine = this.scene.add.graphics({ lineStyle: { width: this.lineWidth, color: dotColor } });
    this.connectLine.lineBetween(this.firstDot.x, this.lastDot.y, this.lastDot.x, this.lastDot.y);

    this.add([this.connectLine, this.firstDot, this.middleDot, this.lastDot]);

    this.workingWidth = this.dotDistance + this.circleSize + this.circleSize * 0.5 + strokeSize;
    this.workingHeight = this.circleSize + strokeSize * 2;

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }

  setDisplay(fillColor, strokeColor, strokeSize) {
    this.colorOutline = strokeColor;
    this.colorFill = fillColor;
    this.sizeOutline = strokeSize;
    this.firstDot.updateDisplay(0xffffff, strokeSize, this.colorFill);
    this.middleDot.updateDisplay(this.colorFill, 1, 0x253453);
    this.lastDot.updateDisplay(0xffffff, strokeSize, this.colorFill);
    this.connectLine.lineStyle(this.lineWidth, this.colorFill).lineBetween(this.firstDot.x, this.lastDot.y, this.lastDot.x, this.lastDot.y);
  }

  select() {
    this.middleDot.updateDisplay(this.colorFill, 0, this.colorFill);
  }

  doIntro(wait, perfect) {
    this.firstDot.scale = 0;
    this.lastDot.scale = 0;
    this.middleDot.scale = 0;
    this.connectLine.alpha = 0;

    if (wait === void (0)) wait = 0;

    let ptime = 100;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop_01b, this.scene, 1, false, wait / 1000);

    this.scene.tweens.timeline(
      {
        tweens:
          [
            ABCyaPhaser.Tweens.createTween(this.firstDot, ptime, { scale: 1.2, offset: wait }, Phaser.Math.Easing.Quadratic.In),
            ABCyaPhaser.Tweens.createTween(this.firstDot, ptime, { scale: 1, offset: wait + ptime }, Phaser.Math.Easing.Quadratic.Out),
          ]
      }
    );

    wait += ptime;

    if (gameData.isAlphabet) {
      ABCyaPhaser.Tweens.addTween(this.connectLine, ptime, { alpha: 1, delay: wait }, Phaser.Math.Easing.Quadratic.In);
      wait += ptime;
    }

    this.scene.tweens.timeline(
      {
        tweens:
          [
            ABCyaPhaser.Tweens.createTween(this.lastDot, ptime, { scale: 1.2, offset: wait }, Phaser.Math.Easing.Quadratic.In),
            ABCyaPhaser.Tweens.createTween(this.lastDot, ptime, { scale: 1, offset: wait + ptime }, Phaser.Math.Easing.Quadratic.Out),
          ]
      }
    );

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop_01b, this.scene, 1, false, wait / 1000);

    wait += 140;

    this.scene.tweens.timeline(
      {
        tweens:
          [
            ABCyaPhaser.Tweens.createTween(this.middleDot, ptime, { scale: 1.2, offset: wait }, Phaser.Math.Easing.Quadratic.In),
            ABCyaPhaser.Tweens.createTween(this.middleDot, ptime, { scale: 1, offset: wait + ptime }, Phaser.Math.Easing.Quadratic.Out),
          ]
      }
    );

    wait += ptime;

    if (!gameData.isAlphabet) {
      ABCyaPhaser.Tweens.addTween(this.connectLine, ptime, { alpha: 1, delay: wait }, Phaser.Math.Easing.Quadratic.In);
    }

    if (perfect) {
      this.showStar();
      this.starSprite.scale = 0;
      this.starSprite.alpha = 0;

      this.scene.tweens.timeline(
        {
          tweens:
            [
              ABCyaPhaser.Tweens.createTween(this.starSprite, ptime, { scale: 1.2, alpha: 1, offset: wait }, Phaser.Math.Easing.Quadratic.In),
              ABCyaPhaser.Tweens.createTween(this.starSprite, ptime, { scale: 1, offset: wait + ptime }, Phaser.Math.Easing.Quadratic.Out),
            ]
        }
      );
    }
  }

  showStar() {
    this.starSprite = ABCyaPhaser.Images.addImage(this.middleDot.x, this.middleDot.y, "star_on", this).setOrigin(0.5);
    this.add(this.starSprite);
  }

  showLevelInfo(fillColor, strokeColor, strokeSize, minNum, maxNum) {
    this.firstDot.updateText(minNum);
    this.lastDot.updateText(maxNum);

    this.colorOutline = strokeColor;
    this.colorFill = fillColor;
    this.sizeOutline = strokeSize;
    this.firstDot.updateDisplay(0xffffff, strokeSize, this.colorFill);
    this.middleDot.updateDisplay(this.colorFill, 1, 0x253453);
    this.lastDot.updateDisplay(0xffffff, strokeSize, this.colorFill);
    this.connectLine.lineStyle(this.lineWidth, this.colorOutline).lineBetween(this.firstDot.x, this.lastDot.y, this.lastDot.x, this.lastDot.y);
    this.middleDot.alpha = 0;
  }
}